import React from 'react';
import { MdRemoveRedEye } from 'react-icons/md';
import Link from 'next/link';
import { useRouter } from 'next/router';

import { GroupDto } from '../../../groups/types';
import { isBounceWebview } from 'legacy/common/utils/webview';

type Props = {
  users: GroupDto[];
  onDelete?: (group: GroupDto) => void;
  isEditable?: boolean;
};

const OrganizationsList = ({ users, onDelete, isEditable }: Props) => {
  const router = useRouter();
  const isWebview = isBounceWebview(router.query);
  const onDeleteHandler = (organization) => () => {
    onDelete(organization);
  };

  return (
    <ul className="flex flex-col gap-4">
      {users.map((organization) => {
        // Temporary fix as payload is not consistent for logged in and non logged in users
        const organizationId = organization?._id || organization?.id;
        return (
          <li
            className="flex align-center bg-primary-50 pl-2 py-2 rounded-lg"
            key={organization.id}
          >
            <Link
              href={!isWebview ? `/organizations/${organizationId}` : ''}
              key={organization.id}
              className="flex align-center flex-1"
            >
              <div className="flex items-center w-14 h-14 rounded-lg justify-center overflow-hidden">
                <img
                  src={organization?.badgeImageUrl || '/img/search/user.svg'}
                  alt={organization.name}
                />
              </div>
              <div className="flex flex-1 flex-col pl-3.5">
                <div className="text-base pb-1">{organization.name}</div>
                <div className="text-gray-400 flex align-center">
                  <MdRemoveRedEye className="mr-1" size={16} />
                  Public Organization
                </div>
              </div>
            </Link>
            {isEditable && (
              <button
                className="p-4"
                onClick={onDeleteHandler(organization)}
                type="button"
              >
                <img src="/img/icons/delete.svg" alt="Delete" />
              </button>
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default OrganizationsList;
